module.exports = __webpack_public_path__ + "img/Academics.777e42be.svg";